// extracted by mini-css-extract-plugin
module.exports = {"container":"_3ODSeaIECwO12urx6speoB"};